<template>
  <v-app id="keep" :class="!isDark ? 'light' : null">
    <div id="panel-body" :class="!isDark ? 'grey lighten-3' : null">
      <Header />
      <v-main class="mb-10">
        <v-container fluid class="fill-height">
          <router-view />
        </v-container>
      </v-main>
      <Footer />
    </div>
  </v-app>
</template>

<script>
import Header from "@/components/Template/Header.vue";
import Footer from "@/components/Template/Footer.vue";
// import View from '@/views/View.vue'
export default {
  name: "Panel",
  inject: ['isDark'],
  components: {
    // 'RouterView': View,
    Header,
    Footer
  },
};
</script>

<style></style>